// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum AlertDigestMode {
	Immediate = 0,
	DailyDigest = 1,
}

export const AlertDigestModeDisplayNames: { [key in keyof typeof AlertDigestMode]?: string} = {
	"Immediate": "Immediate",
	0 : "Immediate",
	"DailyDigest": "Daily Digest",
	1 : "Daily Digest",
}

export const getAlertDigestModeDisplayName = (key: AlertDigestMode | (keyof typeof AlertDigestMode & string)) => {
	return AlertDigestModeDisplayNames[key];
}

